import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/zh-cn/checklists/")({
  head: () => buildRouteHead("/zh-cn/checklists", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/zh-cn/downloads/checklists", replace: true });
  },
});
